module.exports = __webpack_public_path__ + "static/img/meeting.2cbf6fcf.svg";